module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待入库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已出库",
      "name": "4"
    }
  })], 1), _vm._v(" "), (_vm.activeName != 8) ? _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "运单号/订单号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderNo", $$v)
      },
      expression: "search.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户名/vip号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.userName),
      callback: function($$v) {
        _vm.$set(_vm.search, "userName", $$v)
      },
      expression: "search.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "placeholder": "订单号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.orderNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderNumber", $$v)
      },
      expression: "search.orderNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "签收状态"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '4'),
      expression: "activeName == '4'"
    }],
    attrs: {
      "label": "出库时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "clearable": "",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.chukuTime)
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.chukuTime),
      callback: function($$v) {
        _vm.chukuTime = $$v
      },
      expression: "chukuTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '4'),
      expression: "activeName == '4'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出Excel\n              ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bookTip = true
      }
    }
  }, [_vm._v("开放预约\n              ")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '4'),
      expression: "activeName == '4'"
    }]
  }, [_c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总运费:"), _c('span', [_vm._v(_vm._s(_vm.totalFee))])])]), _vm._v(" "), _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  用户人数:"), _c('span', [_vm._v(_vm._s(_vm.totalNum))])])])])], 1)], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "height": "380",
      "stripe": "",
      "id": "printTable",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderSend) ? _c('span', {
          staticClass: "tag tag2"
        }, [_vm._v("已生成")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.productName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "140px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.deliveryTitle) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.batchNumber) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积",
      "prop": "productVolume",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量",
      "prop": "productWeight",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "尺寸",
      "prop": "measure",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n            待入库\n          ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            已入库\n          ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已出库\n          ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已结单\n          ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n            已取消\n          ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （中心仓）已入库\n          ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            （中心仓）已出库\n          ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （派送）已入库\n          ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#ffa500"
          }
        }, [_vm._v("\n            可预约\n          ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#008000"
          }
        }, [_vm._v("\n            已预约\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单费（CAD）",
      "min-width": "140px",
      "align": "center",
      "prop": "demandMoney"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送费(CAD)",
      "min-width": "140px",
      "align": "center",
      "prop": "deliveryAmount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "额外费用（CAD）",
      "min-width": "160px",
      "align": "center",
      "prop": "extraPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "额外费用备注",
      "min-width": "140px",
      "align": "center",
      "prop": "extraPriceRemark"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库时间",
      "width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.format(scope.row.deliveryTime)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "width": "100px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱编号",
      "min-width": "90px",
      "align": "center",
      "prop": "boxNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货柜号",
      "min-width": "90px",
      "align": "center",
      "prop": "containerName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "90px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.status == 9 ||
          scope.row.status == 10 ||
          scope.row.status == 11
        ) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHandler(scope.row)
            }
          }
        }, [_vm._v("出库结算")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), (_vm.activeName == 9 && _vm.accountObj.roleId == 1) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulOutStoreToPay()
      }
    }
  }, [_vm._v("批量出库结算")])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [(_vm.viewDialog.orderInfo.sendNo) ? _c('span', {
    staticClass: "l_label"
  }, [_vm._v("发货单号：")]) : (_vm.viewDialog.orderInfo.orderNo) ? _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单号：")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.orderInfo.sendNo ?
    _vm.viewDialog.orderInfo.sendNo :
    _vm.viewDialog.orderInfo.orderNo))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("VIP号：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.user.vipCode ? _vm.user.vipCode : _vm.viewDialog.orderInfo.vipCode))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.user.realName ? _vm.user.realName : _vm.viewDialog.orderInfo.realName))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value",
    staticStyle: {
      "color": "#20b2aa"
    }
  }, [_vm._v("已入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("入库时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.orderInfo.deliveryEnterTime ?
    _vm.toDate(
      _vm.viewDialog.orderInfo.deliveryEnterTime,
      "yyyy-MM-dd hh:mm:ss"
    ) :
    _vm.toDate(
      _vm.viewDialog.orderInfo.operatorTime,
      "yyyy-MM-dd hh:mm:ss"
    )))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.orderInfo.orderCount ?
    _vm.viewDialog.orderInfo.orderCount :
    _vm.viewDialog.orderInfo.detailList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("所需总运费：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ? _vm.viewDialog.orderInfo.totalFreight : 0))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("所需总工单费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ?
    _vm.viewDialog.orderInfo.totalWorkOrderFee :
    0))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("额外费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ? _vm.viewDialog.orderInfo.extraPrice : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("所需总费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ? _vm.viewDialog.orderInfo.totalCost : 0))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("账户余额：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            "), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v(_vm._s(_vm.user.balance ? _vm.user.balance : _vm.viewDialog.orderInfo.balance))])])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "align": "center",
      "label": "物品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.expressNo ?
          scope.row.expressNo :
          _vm.viewDialog.orderInfo.expressNo) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNum",
      "align": "center",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "货运类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.goodType ?
          _vm.goodTypeName(scope.row.goodType) :
          _vm.goodTypeName(_vm.viewDialog.orderInfo.goodType)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "用户"
    }
  }, [_c('div', [_vm._v("\n                " + _vm._s(_vm.user.realName ?
    _vm.user.realName :
    _vm.viewDialog.orderInfo.realName) + "\n              ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "运费（CAD）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.total ?
          scope.row.total :
          _vm.viewDialog.orderInfo.total) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "demandMoney",
      "align": "center",
      "label": "工费（CAD）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.demandMoney ?
          scope.row.demandMoney :
          _vm.viewDialog.orderInfo.totalWorkOrderFee) + "\n              ")]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-popconfirm', {
    attrs: {
      "title": "您确定结算吗？"
    },
    on: {
      "confirm": _vm.submit,
      "onConfirm": _vm.submit
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    slot: "reference"
  }, [_vm._v("确定结算")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.bookTip,
      "width": "400px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.bookTip = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "warningDia-footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.setReservation
          }
        }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.bookTip = false
            }
          }
        }, [_vm._v("取 消")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("确定确认吗？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("\n      点击确定将会将已入库但未提醒的订单打开预约通道\n    ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_contaner"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单号：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("下单时间：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.toDate(_vm.detailDialog.orderInfo.addTime, "yyyy-MM-dd hh:mm:ss")))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户名称：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户电话：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户vip：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("快递公司：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("商品价值：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.predictTotal))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _vm._v(" "), _c('span', {
    class: 'l_value status' + _vm.detailDialog.orderInfo.status
  }, [_vm._v(_vm._s(_vm.orderStatus(_vm.detailDialog.orderInfo.status)))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("箱编号：")]), _vm._v(" "), _c('span', {
    staticClass: "'l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.boxNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('span', {
    staticClass: "'l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.containerName))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("入库时间：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.storeTime ?
    _vm.toDate(
      _vm.detailDialog.orderInfo.storeTime,
      "yyyy-MM-dd hh:mm:ss"
    ) :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("实际尺寸：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.productLong) + "CM*" + _vm._s(_vm.detailDialog.orderInfo.width) + "CM*" + _vm._s(_vm.detailDialog.orderInfo.height) + "CM")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("实际重量：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.productWeight) + " KG")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("运费：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.orderInfo.total))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("工单费（CAD）：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.demandMoney))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送费(CAD)：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.deliveryAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("额外费用(CAD)：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.extraPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("额外费用备注：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.extraPriceRemark))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("最后总费用：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.orderInfo.totalPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.remark))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("用户备注：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.userRemark))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "productNum",
      "width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productNum) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货架",
      "prop": "shelves",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.shelves) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "prop": "pic",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pic) ? _c('div', _vm._l((scope.row.pic.split(',')), function(item, index) {
          return _c('a', {
            key: index,
            attrs: {
              "href": _vm.detailDialog.orderInfo.httpUrl + item,
              "target": "_blank"
            }
          }, [_c('img', {
            staticClass: "d_pic",
            attrs: {
              "src": _vm.detailDialog.orderInfo.httpUrl + item
            }
          })])
        }), 0) : _vm._e()]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac57983e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/delivery/orderList.vue
// module id = 1258
// module chunks = 2